import { createContext } from "react";
import { Language } from "../Constants/LanguageConstants";

export const LanuageContext = createContext<Language>("cs" as Language);
